// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"0f213162","465":"d9584e57","481":"2bb500a8","565":"936490ba","631":"1bc52bfe"}[chunkId] + ".chunk.css";
};